import React from 'react'
import './blogs.css'
const Samyak_Jain = () => {
    return (
        <div className='blog'>
            <div className='container-fluid'>
                <div className='row blog-row'>
                    <div className='col-md-4'>
                        <img src='placement-postulates/dp/Samyak-Jain.jpg' className='blog-dp' alt='Samyak'></img>
                    </div>
                    <div className='col-md-8'>
                        <div className='blog-head'>
                            <h2>Samyak Jain</h2>
                            <small>Software Developer at Navi Technologies</small>
                        </div>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className='row'>
                        <div>
                        <p><b>This blog is only for the students who are taking placements as their priority. If you are planning to go
          for higher studies or something else, then kindly avoid reading this blog.</b></p>
      <p>
        Hi, I am Samyak Jain, a final year undergraduate in Civil Engineering. I am currently placed at Navi
        technologies, a startup in the BFSI industry, as a Software developer.
        <br/><br/>You might be thinking how a Civil guy lands in the job of software engineer, right? Let’s lookout.
      </p>

      <p>
      <h2>
        <u>Journey</u>
      </h2>
      <img class="blog-image-left" src="placement-postulates/blogs/Samyak-Jain/1.jpg"/>
      During the summers after my second year, I had very little knowledge and direction about the preparation for the
      internship. So, with the advice of seniors, I took one core project. It was good, but I realized it is not
      something I can do in the long term.
      <br/><br/>
      During the summers, I did not start coding (well, I still regret that), and my preparation of aptitude was also
      not good(because they looked easy when I did them once). Result: I did not get an internship through SPO.
      <br/><br/>
      December was coming, and the semester was about to end. I did not want to waste the time of December at home, so
      I started looking for an internship in data analytics as I can present my project in that way (although It was
      not but you can always shape your interview and resume as you want). Of course, I did not have much
      knowledge/experience/skills about other fields, so I started emailing professors of IIM’s working in data
      analytics for an internship in December.
      <br/><br/>
      Luckily one of my 20 emails yielded a positive response, and I got a reply from a prof at IIM Bangalore. I did
      an internship under him for four weeks. I have to filter and analyze the GST dataset of Karnataka state. After
      that, I was sure that I am going in this field only. (Now you wonder how I got into software development? Well,
      thanks to Covid for that)
      </p>
      <p>
      <h2><u>Placement preparation</u></h2>
      <h3>March - April:</h3>
      <img class="blog-image-right" src="placement-postulates/blogs/Samyak-Jain/2.jpg"/>After the lockdown in
      March, I returned home with no plan and lots of
      uncertainty about the situation. I started questioning myself, “why am I just wasting time?”, “this is the
      placement year, and I am not even clear about the profile.” I thought, let’s first complete the internship then
      will look into the profile I will finally be going to sit for. Then around April, everyone around me is getting
      the mail of cancelation of their internship. I contacted the company in which I was going to intern about their
      plans. They said, “we would like to start your internship once the situation gets normal. You have to come to
      Bangalore for the same”. I was happy that at least my internship didn’t get canceled. Days passed, and the
      situation got worse. Finally, my intern has differed till further notification. It was clear that now I have to
      look for another one. During that, I was in contact with one senior of my hall Himanshu Gupta(Y16, he is one of
      the amazing seniors I met at the campus ), who guides me with resources for preparing for placements. Since I
      was enjoying coding, I decided that either I would go for a development internship or just keep brushing up my
      coding skills and prepare for placements (this was a bad backup plan). After sending multiple emails and
      reaching out to contacts on LinkedIn, I landed up as an unpaid intern in a startup named Signo. Work was new for
      me and that gave me some experience related to the backend. After this, I was clear that this is something I can
      do.
      <br/><br/>
      <h3>May-June:</h3>
      It was the time of the internship. I was also coding along with that whenever I get some free time. Also, don’t
      forget to get the PVF signed by your mentor at the end :p
      <br/><br/>
      <h3>July- August:</h3>
      It was the time when I
      was free with the internship. The semester will be
      going to start in September for the first time that year(you know why). It was clear that I will sit in the
      software profile but was not sure as I was having only one intern and nothing else relevant. So as a backup
      plan, I also keep the analyst profile. I started doing code(literally only code).
      <br/>
      For the coding platform, you can choose any but stick to that one till the end of your preparation.
      I chose leetcode for practice. You can go for geeksforgeeks, hackerrank, HackerEarth, codeforces, CodeChef. I
      was more inclined towards leetcode because it has a larger set of problems. By the end of July, I started giving
      contests at leetcode and codeforces. Always analyze the contest and your performance once it ends. Try to do the
      codes which you were not able to do during the contest. Even if you were not able to do it later, it is OKAY.
      Don’t get disheartened and look for the solution or the top-rated answers.
      How to look at the solutions? Don’t mug it up( you should never do this). Instead, try to develop the thought
      process for approaching that solution.
      <br/><br/>
      <h3>September mid- Resume submission:</h3>
      Resume building is an art. It reflects you in front of the interviewer. In my case, it took around 6-8 drafts
      before having a satisfying one. I spent about a week on this. A big thanks to Samyak Jain(Y16, if you know, you
      know :p) for this. He reviews the resume like a pro.
      <br/>I prepare two resumes, one for software profiles and another one for analysts, as a backup.
      <br/><br/>
      <b>Note:- Send every draft to seniors and ask them to review it. Make changes. Again get it reviewed until you
        get a satisfying one.</b>
      <br/><br/>
      <h3>October -November:</h3>
      You will be bombarded with tests during this time. After every test, analyze your performance and questions that
      you could not solve during the test.
      <br/><img class="blog-image-right" src="placement-postulates/blogs/Samyak-Jain/4.jpg"/>If you are not clear
      with which profiles to apply for, then your past
      experience, including internship, projects etc will help you. Try to find your interest. Talk to seniors and
      alumni about their experiences. Do some research on yourself. Be clear before registering on the SPO placement
      portal because you will have an upper limit of 50 profiles for applying. Choose wisely.
      <br/>If you are from a non-CSE/EE/MTH branch, you can apply to all the profiles as 50 is more than enough but
      remember, the more you apply, the more tests you have to give, and you might land in a situation where you are
      giving 2-3 tests in a row.
      <br/><br/>
      
      <h3>November end:</h3>
      End Sems are shifted after placements which gives us a big relief. The stress was at its peak. Luckily I was
      having really good seniors and friends who keep on checking me regularly and try to calm me down. I started
      preparing my resume, revising all the important puzzles, and practicing more and more coding problems.
      <br/>
      By the end of November, we got most of the shortlist for Day 1 and Day 2. Companies release their first
      shortlist and keep a tentative list in case the first shortlist gets exhausted. I was shortlisted in 4 companies
      only in the first shortlist. Again the same things as in internship. I started doubting myself. I was not sure
      whether I would be going to be placed in any good firm. At this point, your peer group will help you a lot. I
      was in constant touch with Vineet Shukla(Y17) during placements. We used to discuss nearly all the tests after
      giving them. It sometimes boosts my confidence and motivation.
      </p>
      <p>
      <h2><u>The D day</u></h2>
      Day 1 and Day 2<br/>
      Yes, I did a lot of mock interviews. Even for the HR interview, I prepared it with 2-3 mocks.<br/>
      I had my first interview with Jaguar Land Rover(SDE) on day 2 first slot. Questions asked were: What is ternary
      search, its comparison with binary search, and time complexity. Then there were 2 dynamic programming problems,
      coin denomination, and egg drop. I was not able to complete the code of the egg drop problem. At last, they also
      asked me about the technologies the jaguar land rover is working on. Again I don’t know the answer to that.
      Result: I was not selected.
      <br/><br/><img class="blog-image-right" src="placement-postulates/blogs/Samyak-Jain/6.jpg"/>
      I was disappointed, and my next interview was in the second slot. Because of that, some companies have started
      releasing extended shortlists. The second slot started at 3 PM. I was sleeping because I don’t want to give an
      interview for the next company and then my phone started ringing. One of my friends told me that I am on the
      extended shortlist of Navi and its interview is about to start. Next min I got a call from the company
      coordinator(CoCo) about the same. I was not in the mood for that, but somehow I changed to formals and waited
      for the link. Then I got a call from another CoCo for the interview for another company. Then the third call,
      that too from a different company.
      <br/><br/>
      I give the first round of Navi. The interviewer asked me a question to reverse a linked list. I started thinking
      for a while using pen and paper but he instructed me to use the code editor so that he could look into my
      thought process (At that point I realised why I screwed up my last interview). I did the code and then he asked
      me to design the splitwise app. It was tough since I did not know about this. I asked him politely what exactly
      he wanted me to do at which he smiled and said just write whatever you think. I made a class, used an unordered
      map, and defined various functions according to need. He was okay with the solution. The round was ended their
      <br/><br/>
      After that, in the second round, the next interviewer asked me to complete a function of a special stack and the
      basics of OOPS. I answer all the questions. Then he asked me about my internship projects. We discussed the
      project on which I worked last summer. He liked that and started explaining the similar thing his team has
      implemented recently. This interview was easier than the first one.
      <br/><br/><img class="blog-image-left" src="placement-postulates/blogs/Samyak-Jain/7.jpg"/>
      Then comes the last round that is the HR round. The interviewer was a person from management.<br/>
      It felt more like a talk than an interview until he asked “why do you want to join Navi? Tell me frankly, is it
      about the pay?” At that point, I was so much franked with him that he started talking in Hindi in between and I
      was not expecting such a cool interviewer. Well, I answered normally about what I feel and later I realised
      there is nothing like a Yes or No answer to that question. It is about how you justify yourself later. After
      that, there were normal questions about “what do you expect from the company”, “how was your last two rounds”
      etc.
      <br/><br/>
      Overall the interview experience was really good and all the interviewers tried to calm me down whenever they
      felt that I was getting panicked.
      <br/><img class="blog-image-right" src="placement-postulates/blogs/Samyak-Jain/8.jpg"/>
      All the interviews at Navi get over by 7 and results will be announced at 3 AM. I was having interviews with two
      more companies, one of which I said no because I don’t like the profile.
      <br/><br/>
      For another i.e Vmock I went to give the interview. He asked me to remove every kth node of the linked
      list(What’s tough was to write the code on google docs). After that, he asked one Question about Dynamic
      programming and then discussed my internship project. Since I talked about the same a few hours back I answered
      it. The interview gets over within 30-35 mins
      <br/><br/>
      At 3 AM I got the call from SPO notifying me that I have been selected in both Navi and Vmock. I immediately
      mailed with my preference and started waking up everyone in the house.
      <br/><br/>
      What After placement? :p<br/>
      <img class="blog-image-left" src="placement-postulates/blogs/Samyak-Jain/9.jpg"/>
      <span class="memetext">(Credits: IIT meme hub)</span>
      </p>
      <p>
      <h2><u>
          Resources
        </u></h2>
      Keep your resources limited during the preparation phase when you are practicing and learning new concepts. Once
      you are confident then you can switch to other platforms.
      <br/><br/>
      For coding:
      <ul>
        <li>
          <a target="_blank" href="https://leetcode.com/problemset/top-100-liked-questions/" class="links">Leetcode</a>
          and <a target="_blank" href="https://www.interviewbit.com" class="links">Interviewbit</a>(this is must try to
          do every problem in
          this)
        </li>
        <li>
          After your preparation is completed try to give a contest on leetcode or/and codeforces to improve the
          speed
        </li>
        <li>
          Geeks for geeks(GFG)
        </li>
      </ul>
      For aptitude
      <ul>
        <li>
          <a target="_blank" href="https://jobs.prepleaf.com/" class="links">Prepleaf</a>
        </li>
        <li>
          For speed, you can give the CAT test every week or 2 times a week. Refer <a target="_blank"
            href="http://spo.iitk.ac.in/preparation/" class="links"> spo placement resources </a> of that
        </li>
      </ul>
      For puzzles
      <ul>
        <li>
          50 challenging problems in probability
        </li>
        <li>
          <a target="_blank" href="https://brainstellar.com/" class="links">Brainsteller</a>
        </li>
        <li>
          <a target="_blank" href="https://www.interviewbit.com/puzzles/" class="links"> Interviewbit</a>
        </li>
        <li>
          <a target="_blank" href="https://gurmeet.net/puzzles/" class="links">More Puzzles</a>
        </li>
      </ul>
      For HR
      <ul>
        <li>
          <a target="_blank" href="https://www.youtube.com/playlist?list=PLQqfhrN5hwqq2cc-00lE4lad1DWmd1_4c"
            class="links">Prepleaf playlist</a>
        </li>
        <li>
          <a target="_blank" href="https://docs.google.com/document/d/1ijco-U6PcTKV_kJzk2zcN80WFdDMy6kzzTz78oZ44Tc/edit"
            class="links">Frequently Asked Questions</a> (credits to owner)
        </li>
      </ul>
      </p>
      <p>
      <h2><u>Highlights and Tips</u></h2>
      <img class="blog-image-right" src="placement-postulates/blogs/Samyak-Jain/10.jpg"/>
      <ul>
        <li>
          Take care of your physical and mental health. Never compromise that at any cost.
        </li>
        <li>
          Earlier you start with clarity of profile in mind, better you prepare.
        </li>
        <li>
          Analyse your performance after every test, learn from mistakes and never mug up the solutions.
        </li>
        <li>
          Keep your placement sem light. I took 5 courses out of which one was modular.
        </li>
        <li>
          The DSA course(ESO207) is a must. I would recommend doing it on campus if you were not able to get it
          then do it from online platforms
        </li>
        <li>
          ML course/ project will be a good add-on to resume. If you were not able to do it on campus(CS771) then
          you can refer to Coursera, udemy etc.
        </li>
        <li>
          Prepare your resume by heart. They can even ask about your hobbies and interests if it is written there.
        </li>
        <li>
          Stay in contact with your close ones including friends, family, etc. Share your feelings with them it
          will help you to deal with stress during the placements
        </li>
        <li>
          Prepare your resume wisely. Don’t spend time on things that you can’t change(like CPI) rather focus on
          making rest of the things impactable
        </li>
        <li>
          Improve your speed in aptitude. It is asked in almost all the tests.
        </li>
        <li>
          Practice mock coding interviews with peers/seniors to avoid messing the real interviews
        </li>
        <li>
          Don’t take HR lightly. It really hurts if you are eliminated at this round. Prepare with at least 2-3
          mocks for this.
        </li>
        <li>
          Give your portal login credentials to 2-3 friends who are not sitting in placements so that they can
          check your portal regularly during interviews.
        </li>
        <li>
          Be consistent in coding. That’s the only way to ace the coding skills
        </li>
        <li>
          Be confident and stay calm. You're gonna do your best!
        </li>
      </ul>
      </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Samyak_Jain